<template>

    <div class="animated fadeIn" v-if="queryAnswerType.uuid">

        <b-row class="py-2">

            <b-card header="Nueva Respuesta Tipo" class="w-100">

                <query-answer-type-form
                    class="px-3"
                    :query-answer-type="queryAnswerType"
                    :renderDeleteButton="mixinCheckPermission('QUERY_ANSWER_TYPE_DELETE')"
                    :renderSaveButton="mixinCheckPermission('QUERY_ANSWER_TYPE_EDIT')"
                    @submit-query-answer-type="updateQueryAnswerType($event)"
                    @delete-query-answer-type="deleteQueryAnswerType()">
                </query-answer-type-form>

            </b-card>

        </b-row>

    </div>

</template>

<script>

    import QueryAnswerTypeForm from './QueryAnswerTypeForm';
    import {updateQueryAnswerType, deleteQueryAnswerType, getQueryAnswerType} from '@/api/query-answer-type-api';

    export default {
        name: "AddQueryAnswerType",
        components: {QueryAnswerTypeForm},
        comments: {
            QueryAnswerTypeForm
        },

        data: function () {
            return {
                topmenu: [
                    {
                        name: 'Volver',
                        path: '/queries/answer-types/list',
                        brand: 'fa fa-arrow-left'
                    },
                ],
                queryAnswerType: {

                }
            };
        },

        mounted() {
            this.$eventHub.$emit('captureMenu', this.topmenu);
            this.getQueryAnswerType();
        },

        methods: {

            async getQueryAnswerType() {
                this.$_loadingMixin_showLoading();
                await getQueryAnswerType(this.$route.params.uuid)
                    .then((queryAnswerType) => {
                        this.queryAnswerType = queryAnswerType;
                    });
                this.$_loadingMixin_hideLoading();
            },

            updateQueryAnswerType(queryAnswerType) {
                this.$_loadingMixin_showLoading();
                updateQueryAnswerType(queryAnswerType)
                    .then(() => {
                        this.$_notificationMixin_success('Operación Completada', 'Realizado con éxito');
                        this.$_loadingMixin_hideLoading();
                        this.$router.push({path: '/queries/answer-types/list'});
                    })
                    .catch(() => {
                        this.$_notificationMixin_error('Operación denegada', 'Algo salió mal');
                        this.$_loadingMixin_hideLoading();
                    });
            },

            deleteQueryAnswerType() {

                swal({
                    title: '¿Estás seguro de eliminar esta respuesta tipo?', text: "Esta operación no se podrá revertir", type: 'warning',
                    showCancelButton: true, cancelButtonText: 'Cancelar', confirmButtonText: 'Sí, elimínalo!'
                }).then((result) => {
                    if (result.value) {

                        this.$_loadingMixin_showLoading();
                        deleteQueryAnswerType(this.$route.params.uuid)
                            .then(() => {
                                this.$_notificationMixin_success('Operación Completada', 'Realizado con éxito');
                                this.$_loadingMixin_hideLoading();
                                this.$router.push({path: '/queries/answer-types/list'});
                            })
                            .catch(() => {
                                this.$_notificationMixin_error('Operación denegada', 'Algo salió mal');
                                this.$_loadingMixin_hideLoading();
                            });

                    }
                });
            }
        }
    }
</script>